import { useTranslation } from 'react-i18next';

import { StatusBadge, TStatusBadgeProps } from '@treezor/design-system';

import { UserStatusLabel } from '../../store';

import { InfoTooltip } from '@/ui-kit/Tips/InfoTooltip';

type TUserStatus = Pick<TStatusBadgeProps, 'color' | 'label'> & { status?: keyof typeof UserStatusLabel };

export function UserStatus(status: TUserStatus) {
  const { t } = useTranslation();
  return (
    <div className="flex gap-3 whitespace-nowrap">
      <StatusBadge size="s" emphasis="low" color={status.color} label={status.label} />
      {status.status === UserStatusLabel.BLOCKED && (
        <InfoTooltip
          tooltipInfo={
            <div>
              <span className="typo-body-bold-paragraph">
                {t('pages.dashboard.users.tooltips.blockedUser.mainInfo')}
              </span>
              {t('pages.dashboard.users.tooltips.blockedUser.additionalInfo')}
            </div>
          }
          infoClassName="max-w-[400px] w-[400px]"
        />
      )}
    </div>
  );
}
